import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AttachmentDto } from '@ellf/common-dto';
import { ApiClientConfig } from './api-client-config';

@Injectable()
export class FileApiClient {
  baseUrl = this.config.apiEndpoint + '/file';

  upload(list: FileList) {
    const files = Array.from(list);
    const fd = new FormData();
    files.forEach((file) => fd.append('files', file));
    return this.http.post<AttachmentDto[]>(this.baseUrl + '/upload', fd);
  }

  download(attachment: AttachmentDto) {
    return this.http.post(this.baseUrl + '/download', attachment, {
      responseType: 'arraybuffer',
    });
  }

  uploadTimetableExcel(list: FileList) {
    const files = Array.from(list);
    const fd = new FormData();
    files.forEach((file) => fd.append('files', file));
    return this.http.post<any>(this.baseUrl + '/upload-timetable-excel', fd);
  }

  constructor(
    private http: HttpClient,
    private config: ApiClientConfig,
  ) {}
}
